import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      isLoggedIn: false,

      setAuth: (accessToken, user) =>
        set({
          accessToken,
          user,
          isLoggedIn: true,
        }),

      clearAuth: () =>
        set({
          accessToken: null,
          user: null,
          isLoggedIn: false,
        }),
    }),
    {
      name: "legacy-auth",
    },
  ),
);
